let featureData = [
    {
        id: 1,
        img: "assets/images/womenfeature.png",
        heading: "Woman 2020 Summer Collection",
        button: "Shop Now",
        position: "top",
    },
    {
        id: 2,
        img: "assets/images/manfeature.png",
        heading: "Men 2020 Summer Collection",
        button: "Shop Now",
        position: "bottom",
    },
]
module.exports = featureData;